/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { Button, FlexView, Spinner } from 'components/common'
import { Input, Select } from 'components/form'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import { useContext } from 'react'
import { StockContext } from 'stores/StockStore'
import { UserContext } from 'stores/UserStore'
import { useHistory } from 'react-router-dom'
import {Multiselect} from 'multiselect-react-dropdown'
// import { withMaxHeight } from 'utils/styled-decorators'
// import { borderRadius } from 'stories/components/common/LoadingOverlay/LoadingOverlay.stories'

const FormWrapperOne = styled(FlexView)`
  width: 100%;
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;

  @media screen and (max-width: 1100px) {
    grid-template-columns: 33.3% 33.3% 33.4%;
  }

  input {
    padding: 8px;
    min-height: 0px;
  }
`
const FormWrapperTwo = styled(FlexView)`
  width: 100%;
  display: grid;
  grid-template-columns: 25% 25% 50%;
  align-items: flex-start;
  @media screen and (max-width: 1100px) {
    grid-template-columns: 33.3% 33.3% 33.4%;
  }

  input {
    padding: 8px;
    min-height: 0px;
    overflow: auto;
  }
`

const FormWrapperThree = styled(FlexView)`
  width: 100%;
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  align-items: flex-end;
  @media screen and (max-width: 1100px) {
    grid-template-columns: 30.3% 30.3% 30.4% 14%;
  }

  input {
    padding: 8px;
    min-height: 0px;
  }
`

const DEFAULT_URL = "services-stock/home"
const DEFAULT_FORM_STATE = {
  ippn: '',
  client: '',
  center: '',
  sot: '',
  nm: '',
  nmDescription: '',
  materialStatus: [''],
  invoice: '',
  warehouse: '',
  reservation: ''
}

const SearchForm = () => {
  const history = useHistory()
  const { t } = useTranslation()
  const { registryLog } = useContext(UserContext)
  const [loadingMaterials, setLoadingMaterials] = useState(false)
  const [selectedMaterials, setSelectedMaterials] = useState([{ label: 'Todos', value: '' }])
  // const { registryLogOld } = useContext(UserContext)

  const [formState, setFormState] = useState(DEFAULT_FORM_STATE)

  const [checkingDigitState, setCheckingDigitState] = useState(false)
  const { getServiceDetailsData, queryData, options } = useContext(StockContext)

  const emptyFilter = useMemo(() => _.isEqual(formState, DEFAULT_FORM_STATE), [formState])

  const selectAllOption = useMemo(() => ({
    label: t('service.selectAll'),
    value: ''
  }), [t])

  const multiselectCss = {
    multiselectContainer: {},
    searchBox: {
      maxHeight: '40px',
      borderRadius: '8px',
      marginBottom: '10px',
      marginTop: '0px',
      overflow: 'auto'
    },
    inputField: {},
    chips: {
      borderRadius: '8px',
      // maxWidth: '150px', 
      textOverflow: 'ellipsis'
    },
    optionContainer: {
      fontSize: '12px',
      boxShadow: 'rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px, rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px',
      borderRadius: '12px'
    },
    option: {
      padding: '3px 10px'
    }
  }

  const optionsCenter = useMemo(() => {
    return options.center ? [
      ...options.center.map(value => ({
        label: value,
        value
      })),
      selectAllOption
    ] : [selectAllOption]
  }, [options, selectAllOption])

  const optionsClient = useMemo(() => {
    return options.client ? [
      ...options.client.map(value => ({
        label: value,
        value
      })),
      selectAllOption
    ] : [selectAllOption]
  }, [options, selectAllOption])

  const optionsWarehouse = useMemo(() => {
    return options.warehouse ? [
      ...options.warehouse.map(value => ({
        label: value,
        value
      })),
      selectAllOption
    ] : [selectAllOption]
  }, [options, selectAllOption])

  const optionsMaterialStatus = useMemo(() => {
    return options.status ? [
      ...options.status.map(value => ({
        label: t('service.selectStatus' + value),
        value
      })),
      selectAllOption
    ] : [selectAllOption]
  }, [options, t, selectAllOption])

  const handleSelectInput = name => value => {
    setFormState(currentState => ({
      ...currentState,
      [name]: value
    }))
  }

  const onMaterialSelect = useCallback((selectedList) => {
    let materials = []
    
    console.log('selectedList', selectedList)
    // eslint-disable-next-line
    selectedList.map(item => {
      console.log('item', item)
      materials.push(item.value)
    })

    if (materials && materials.length > 0 && materials[0] === '') {
      materials.shift()
      selectedList.shift()
    }

    if (materials && materials.length > 0 && materials[materials.length - 1] === '') {
      selectedList = [{ label: 'Todos', value: '' }]
      materials = ''
    }

    console.log('materials', materials)
    setFormState(currentState => ({
      ...currentState,
      'materialStatus': materials
    }))
    setSelectedMaterials(selectedList)
  }, [])

  const checkDigitIppn = (value) => {
    let checksum = 0
    let checkDigit = 0
    let valueArray = []
    valueArray = value

    for (let i = 0; i < valueArray.length; i++) {
      checksum = checksum + (valueArray[i] * (valueArray.length - i + 1))
    }
    checkDigit = checksum % 10
    return checkDigit.toString()
  }

  const handleInputChange = (event) => {
    event.persist()
    let checkdigit = 0
    if (event.target.name === "ippn") {
      event.target.value = event.target.value.replace(/[^0-9]/g, '')
      if (event.target.value.length > 12) {
        checkdigit = checkDigitIppn(event.target.value.substring(0, 12))
        if (checkdigit !== event.target.value[12]) {
          setCheckingDigitState(true)
        } else {
          setCheckingDigitState(false)
        }
      }
    }
    setFormState(currentState => ({
      ...currentState,
      [event.target.name]: event.target.value
    }))
  }

  const formRegistryLog = () => {
    const filters = _.pickBy(formState, value => (typeof value === 'string' && value.length) || value)
    for (var item in filters) {
      if (item !== 'compress') {
        registryLog(DEFAULT_URL, 'searching', item)
      }
    }
    registryLog(DEFAULT_URL, 'click', 'search')
  }

  const onSubmit = () => {
    formRegistryLog()
    console.log('FORMSTATE', formState)
    getServiceDetailsData(formState)
      .then(history.push("/stock"))
      .catch(error => {
        console.debug(error)
      })
  }

  const LabelMultiselect = ({ label, loading }) => {
    return (
      <FlexView flexDirection="row" justifyContent="flex-start" margin="4px 0px">
        <FlexView color="black" fontSize="medium" style={{ marginBottom: "5px" }} fontWeight="700">{label}</FlexView>
        {loading ? <Spinner style={{ margin: "10px 10px 15px" }} size="medium" /> : <></>}
      </FlexView>
    )
  }

  useEffect(() => {
    queryData['materialStatus'] = ['']
    setFormState(queryData)
  }, [t, queryData])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (!emptyFilter) {
        onSubmit()
      }
    }
  }

  return (
    <>
      <FormWrapperOne
        flexDirection="row"
        flexWrap="wrap"
        padding="0px"
        margin="0px -8px">
        <FlexView padding="1px 8px 0px">
          <Input margin="0px" label={t('service.inputIppn')} width="100%" onChange={handleInputChange} name="ippn" value={formState.ippn} message={checkingDigitState ? t('service.inputCheckingDigit') : ''} messageType={checkingDigitState ? "warning" : ''} onKeyDown={handleKeyDown} />
        </FlexView>

        <FlexView padding="1px 8px 0px">
          <Input margin="0px" label={t('service.inputSot')} width="100%" onChange={handleInputChange} name="sot" value={formState.sot} onKeyDown={handleKeyDown} />
        </FlexView>

        <FlexView padding="1px 8px 0px">
          <Input margin="1px 0px 0px" label={t('service.inputReservation')} width="100%" onChange={handleInputChange} name="reservation" value={formState.reservation} onKeyDown={handleKeyDown} />
        </FlexView>

        <FlexView padding="1px 8px 0px">
          <Input margin="1px 0px 0px" label={t('service.inputInvoice')} width="100%" onChange={handleInputChange} name="invoice" value={formState.invoice} onKeyDown={handleKeyDown} />
        </FlexView>
      </FormWrapperOne>
      <FormWrapperTwo
        flexDirection="row"
        align
        flexWrap="wrap"
        padding="0px"
        margin="0px -8px">
        <FlexView padding="1px 8px 0px">
          <LabelMultiselect label={t('service.inputMaterialStatus')} loading={loadingMaterials} />
          <Multiselect
            id="materials"
            selectedValues={selectedMaterials}
            options={optionsMaterialStatus}
            onSelect={onMaterialSelect}
            onRemove={onMaterialSelect}
            displayValue="label"
            showCheckbox={true}
            showArrow={true}
            closeOnSelect={false}
            placeholder={t('search') + '...'}
            emptyRecordMsg={t('empty-data')}
            style={multiselectCss}
            loading={loadingMaterials}
            loadingMessage={t('loading')}/>
        </FlexView>
        <FlexView padding="7px 8px 0px">
          <Input margin="0px" label={t('service.inputNm')} width="100%" onChange={handleInputChange} name="nm" value={formState.nm} onKeyDown={handleKeyDown} />
        </FlexView>
        <FlexView padding="7px 8px 0px">
          <Input margin="0px" label={t('service.inputNmDescription')} width="100%" onChange={handleInputChange} name="nmDescription" value={formState.nmDescription} onKeyDown={handleKeyDown} />
        </FlexView>
        </FormWrapperTwo>
    <FormWrapperThree
      flexDirection="row"
      align
      flexWrap="wrap"
      padding="0px"
      margin="0px -8px">
          <FlexView padding="1px 8px 0px">
            <Select placeholder={t('service.selectAll')} margin="0px" label={t('service.inputWarehouse')} options={optionsWarehouse}  onChange={handleSelectInput('warehouse')} value={formState.warehouse} width="100%" onKeyDown={handleKeyDown} />
          </FlexView>
          <FlexView padding="1px 8px 0px">
            <Select placeholder={t('service.selectAll')} margin="0px" label={t('service.inputClient')} options={optionsClient} onChange={handleSelectInput('client')} value={formState.client} width="100%"  />
          </FlexView>
          <FlexView padding="1px 8px 0px">
            <Select placeholder={t('service.selectAll')}  margin="0px" label={t('service.inputCenter')} options={optionsCenter} onChange={handleSelectInput('center')} value={formState.center} width="100%"  />
          </FlexView>
        
        <FlexView >
            <Button  alignSelf="flex-end" backgroundColor="primary" color="white" fontSize="big" onClick={onSubmit} disabled={emptyFilter} width="100%">
              {t('service.searchButton')}
            </Button>
        </FlexView>
      </FormWrapperThree>

    </>
  )


}

export default SearchForm
